import { setupWorker } from 'msw/browser';

import { createMockHandlers } from './handlerFactory';

// No brand specified — handlers auto-detect from request URL
export const worker = setupWorker(...createMockHandlers());
